// Errori di validazione del backend (flowValidator.js / nodeManifest.js): ognuno
// porta un `code` stabile e, se il testo ha parti dinamiche, `params`. Qui il
// codice diventa la chiave i18n `flowEditor.validation.backend.<code>`; senza
// codice (errori salvati prima dei codici) o senza traduzione resta il
// messaggio del backend.
const KEY_PREFIX = 'flowEditor.validation.backend.';

/**
 * @param {{code?: string, params?: object, message: string}|null|undefined} error
 * @param {{t: Function, te: Function}} i18n - `t`/`te` di vue-i18n
 * @returns {object|null|undefined} una copia con `message` tradotto se il
 *   codice e' noto, altrimenti l'errore cosi' com'e'
 */
export function localizeValidationError(error, { t, te }) {
  if (!error?.code) return error;
  const key = KEY_PREFIX + error.code;
  if (!te(key)) return error;
  return { ...error, message: t(key, error.params || {}) };
}
